import { render, staticRenderFns } from "./MenuRouteItem.vue?vue&type=template&id=7a9f8e78&scoped=true"
import script from "./MenuRouteItem.vue?vue&type=script&lang=js"
export * from "./MenuRouteItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9f8e78",
  null
  
)

export default component.exports